export interface UnboxingCtaButtonProps {
  variant: "filled" | "clear";
  icon: React.ReactNode;
  children: React.ReactNode;
  onClick?: () => void;
  /** Mobile stacks the CTAs: Unwrap goes full-width, Read Message is demoted to a
   *  dust-ink text link — matches the recipient prototype's giftUnboxing.css. */
  isMobile?: boolean;
}

export default function UnboxingCtaButton({
  variant,
  icon,
  children,
  onClick,
  isMobile = false,
}: UnboxingCtaButtonProps) {
  const filled = variant === "filled";

  // Mobile "clear" (Read Message) → quiet dust-ink text link (no border/pill,
  // no uppercase/tracking), per giftUnboxing.css .gub-cta-clear @max-width:720px.
  if (isMobile && !filled) {
    return (
      <button
        type="button"
        onClick={onClick}
        className="inline-flex w-full items-center justify-center gap-2 font-lato text-[14px] font-bold select-none cursor-pointer bg-transparent hover:underline"
        // R01: padding grows the hit box to 44px tall; the equal negative margin keeps the
        // text and surrounding layout exactly where they were (no visual/layout shift).
        style={{ color: "var(--color-dust-ink)", padding: "12px 0", margin: "-8px 0" }}
      >
        {icon}
        {children}
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className={[
        "inline-flex items-center justify-center gap-2 font-lato text-[14px] font-bold tracking-[0.5px] uppercase",
        "border-2 border-rodeo-black select-none cursor-pointer",
        "transition-all duration-150 hover:scale-[1.03]",
        filled
          ? "bg-rodeo-black text-white hover:bg-background-dark"
          : "bg-transparent text-rodeo-black hover:bg-black/5",
        isMobile ? "w-full" : "",
      ].join(" ")}
      style={{ borderRadius: 24, padding: isMobile ? "14px 32px" : "10px 32px" }}
    >
      {icon}
      {children}
    </button>
  );
}
